import React from 'react'

const ReturnPageIcon = (props) => {
  const { color } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="24px"
      width="24px"
      color={color}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
        fill="currentColor" />
    </svg>
  )
}

export default ReturnPageIcon



// WEBPACK FOOTER //
// ./src/components/icons/ReturnPageButton.js